import LogoMark from "../Logo";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="footer" data-bg="grey" data-testid="footer">
    <div className="footer-inner">
      <div className="footer-top">
        <div>
          <div className="footer-brand-row">
            <LogoMark size={44} />
            <div className="footer-brand">Aria<span className="dot">.</span></div>
          </div>
          <p className="footer-tag">
            AI Business Transformation · Hyderabad · Est. 2025<br />
            Built for 2036. Available today.
          </p>
        </div>
        <div className="footer-col">
          <div className="footer-col-title">Solutions</div>
          <ul>
            <li>WhatsApp AI Bot</li>
            <li>Business Diagnosis</li>
            <li>10-Year Vision</li>
            <li>Custom Integrations</li>
          </ul>
        </div>
        <div className="footer-col">
          <div className="footer-col-title">Industries</div>
          <ul>
            <li>Schools & Colleges</li>
            <li>Clinics & Hospitals</li>
            <li>Restaurants & Cafés</li>
            <li>Retail & Real Estate</li>
          </ul>
        </div>
        <div className="footer-col">
          <div className="footer-col-title">Contact</div>
          <ul>
            <li><a href="https://wa.me/917995495312" target="_blank" rel="noreferrer">+91 79954 95312</a></li>
            <li><a href="mailto:start@aria4u.com">start@aria4u.com</a></li>
            <li><Link to="/privacy" data-testid="footer-privacy">Privacy</Link></li>
            <li><a href="#">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bot">
        <div>© 2025 Aria. Hyderabad, India.</div>
        <div>We don't sell chatbots. We install the future.</div>
      </div>
    </div>
  </footer>
);

export default Footer;
